var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleInvestor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.10004 10.423C10.1727 0.968695 16.489 0.859674 19.0131 1.98695C20.1404 4.51105 20.0314 10.8274 10.5771 15.9C10.4791 15.3364 9.93379 13.8599 8.53697 12.4631C7.14015 11.0663 5.66367 10.521 5.10004 10.423Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8501 15.45C13.6886 16.35 13.8849 17.9638 14.1395 19.5C14.1395 19.5 17.9902 16.6535 15.5271 12.75",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.54999 9.22694C4.64999 7.38844 3.03618 7.19215 1.50003 6.93746C1.50003 6.93746 4.34653 3.08682 8.25 5.54993",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.51811 13.4113C4.00628 13.9231 3.13616 15.4074 3.75036 17.25C5.59296 17.8642 7.07729 16.9941 7.58912 16.4823",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8008 6.95007C15.8008 5.98357 15.0173 5.20007 14.0508 5.20007C13.0843 5.20007 12.3008 5.98357 12.3008 6.95007C12.3008 7.91657 13.0843 8.70007 14.0508 8.70007C15.0173 8.70007 15.8008 7.91657 15.8008 6.95007Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleInvestor);
export default __webpack_public_path__ + "static/media/ToggleInvestor.ebbedc22ede160710e2779d9f51f1c25.svg";
export { ForwardRef as ReactComponent };